export const MOBILE_NAV_HEIGHT = `50px`;
export const DESKTOP_NAV_HEIGHT = `80px`;

export const LINKS = [
  { page: `About`, url: `/` },
  { page: `Blog`, url: `/blog/` },
  { page: `CV`, url: `/cv/` },
];
